module.exports = __webpack_public_path__ + "img/4-gray-cartoon.8d443e5b.png";